import sanitizer from '@helpers/sanitizer';
import React, { CSSProperties, forwardRef, PropsWithChildren } from 'react';

interface TypographyProps extends CSSProperties, PropsWithChildren {
  id?: string;
  variant?: 'body1' | 'body2' | 'title';
  bold?: boolean;
  className?: string;
  hasInnerHTML?: boolean;
}

const Typography = forwardRef<HTMLDivElement, TypographyProps>(
  ({ id, variant, bold, className, hasInnerHTML, children, ...props }, ref) => {
    if (typeof children !== 'string') {
      return children;
    }

    const customStyles: CSSProperties = {
      ...props,
      fontWeight: bold ? 'bold' : 'normal',
    };

    switch (variant) {
      case 'body1':
        customStyles.fontSize = '0.75rem'; //12px
        break;
      case 'body2':
        customStyles.fontSize = '0.875rem'; //14px
        break;
      case 'title':
        customStyles.fontSize = '1rem'; //16px
        customStyles.fontWeight = bold === undefined ? 'bold' : props.fontWeight || 'normal';
        break;
      default:
        break;
    }

    return (
      <div
        id={id}
        ref={ref}
        style={customStyles}
        className={className}
      >
        {hasInnerHTML && (
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizer(children),
            }}
          />
        )}
        {!hasInnerHTML && children}
      </div>
    );
  },
);

export default Typography;
